import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Input as BaseInput } from '@mui/base/Input';
import { getFilteredInvoiceList } from "../../../api/freight";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { addInsuranceCharge, getSASToBlob, searchInsuranceCharge } from "../../../api/po";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";
import Grid from '@mui/material/Grid';
import SweetAlert from "react-bootstrap-sweetalert";
const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const Insurance = () => {

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Insurance Invoice'))

    const [showList, setShowList] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedVendorName, setSelectedVendorName] = useState('');
    const [selectedInvoiceDate, setSelectedInvoiceDate] = useState('');
    const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
    const [message, setMessage] = useState("");
    const [file, setFile] = useState('');


    const [insuranceNoSet, setInsuranceNoSet] = useState(null);

    const [approvalrows, setApprovalrows] = useState([]);
    const [options, setOptions] = useState({
        insurance_no: '',
        insurance_no_error: '',
        item: 'Insurance Charge',
        item_error: '',
        quantity: '',
        quantity_error: '',
        unit_price: '',
        unit_price_error: '',
        total: '',
        conversion_rate: '',
        conversion_rate_error: '',
        amount: ''
    });
    const [isSubmitModalOpen, setSubmitModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [payload, setPayload] = useState(null);


    const handleInputChange = (value, input_name) => {
        
        let prev = {...options};
        prev[input_name] = value;

        if(input_name == 'quantity' || input_name == 'unit_price'){
            prev['total'] = Number(prev['quantity']) * Number(prev['unit_price']);
            prev['amount'] = Number(prev['total']) * Number(prev['conversion_rate']);
        }

        if(input_name == 'conversion_rate'){
            prev['amount'] = Number(prev['total']) * Number(prev['conversion_rate']);
        }

        setOptions(prev);
    
    }

    const handleButtonClick = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const toggleList = () => {
        setShowList(!showList);
    };
    const Input = React.forwardRef(function CustomInput(props, ref) {
        return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
    });
    document.title = "Dashboard | Procurement Dashboard";
    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

        const columns = [
            {
                field: 'Sl_No', headerName: 'Sl.No', flex: .5,
                resizable: false,
                sortable: false,
            },
            {
                field: 'vendor_name',
                headerName: 'Vendor Name',
                headerClassName: 'break-header',
                cellClassName: 'product_name_wrap',
                width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field: 'date',
                headerName: 'Date',
                headerClassName: 'table-header-background',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
            },
            {
                field: 'insurance_no',
                headerName: 'Insurance Number',
                headerClassName: 'break-header',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
                // headerAlign: 'center',
                // cellClassName: 'center-aligndata',
            },
            {
                field: 'item',
                headerName: 'Item',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },
            {
                field:'Quantity',
                headerName: 'QTY',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            }, 
            {
                field: 'Unit_price',
                headerName: 'Unit Price',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },    
            {
                field: 'total',
                headerName: 'Total (Auto)',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            }, 
            {
                field: 'conversion_rate',
                headerName: 'Exchange Rate',
                headerClassName: 'break-header',
                // headerAlign: 'center',
                // cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },   
            {
                field: 'amount',
                headerName: 'Amount (Auto)',
                headerClassName: 'table-header-background',
                headerAlign: 'center',
                cellClassName: 'center-aligndata',
                // width: 160,
                editable: false,
                resizable: false,
                sortable: false,
                flex: 1,
            },  
        ];
    
        // const approvalrows = [
        //     { id: 1, Sl_No: 1,vendor_name:"Zhonghan Wantai", date: '28-03-2024',insurance_no:'INSN1',item:'Insurance Charge',qty:1,unit_price:1000,total:1000,conversion_rate:80, amount:30000,},
        //     { id: 2, Sl_No: 2,vendor_name:"Zhonghan Wantai", date: '28-03-2024',insurance_no:'INSN1',item:'Insurance Charge',qty:1,unit_price:1000,total:1000,conversion_rate:80, amount:30000,},
        // ];

        const getFilteredInvoiceListFromBackend = async () => {
            try {
    
              const response = await getFilteredInvoiceList('INSURANCE');
                
              console.log("getFilteredInvoiceList response:", response);
    
              setInvoiceList(response.data?.invoiceList?.map(el => ({...el, label: el?.invoice_number})));

              setInsuranceNoSet(new Set(response.data?.setData))
    
            } catch (error) {
              toast.error("Error in fetching invoice data");
              console.log(error);
            }
        };
    
        useEffect(() => {
            getFilteredInvoiceListFromBackend()
            // searchFreightChargeFromBackend();
        }, []);

        const handleSubmit = async () => {
            try {
                let hasError = false;
                let newOptions = {...options};
                if(!newOptions.insurance_no){
                    newOptions.insurance_no_error = 'Insurance no is required!';
                    hasError = true;
                } else if(insuranceNoSet && insuranceNoSet.has(newOptions.insurance_no)){
                    newOptions.insurance_no_error = 'Insurance no already exists!';
                    hasError = true;
                }
    
                if(!newOptions.quantity){
                    newOptions.quantity_error = 'Quantity is required!';
                    hasError = true;
                }

                if(!newOptions.item){
                    newOptions.item_error = 'Item is required!';
                    hasError = true;
                }
    
                if(!newOptions.unit_price){
                    newOptions.unit_price_error = 'Unit price is required!';
                    hasError = true;
                }
    
                if(!newOptions.conversion_rate){
                    newOptions.conversion_rate_error = 'Exchange rate price is required!';
                    hasError = true;
                }
    
                if(hasError){
                    setOptions(newOptions);
                    return;
                }
    
    
                /*
                invoice_id: bigint,
    insurance_no: string,
    quantity: number,
    unit_price: number,
    total: number,
    amount: number,
    conversion_rate: number
    
                */
    
                const data = {
                    invoice_id: selectedInvoice.id,
                    insurance_no: options.insurance_no,
                    quantity: options.quantity,
                    unit_price: options.unit_price,
                    total: options.total,
                    amount: options.amount,
                    conversion_rate: options.conversion_rate
                };

                setPayload(data);
    
    
                
                setSubmitModalOpen(true);
    
    
            } catch (error) {
                toast.error("Error in submitting invoice data");
                console.log(error);
            }
        }

        // const searchInsuranceChargeFromBackend = async (id) => {
        //     try {

        //     const response = await searchInsuranceCharge(id);
                
        //     console.log("searchFreightCharge response:", response);

        //     addApprovalRows(response.data.insurances)
        //     } catch (error) {
        //     toast.error("Error in fetching invoice data");
        //     console.log(error);
        //     }
        // };

        // const addApprovalRows = (result) => {
        //     if (result.length > 0) {
        //         const formattedProducts = result.map((product, index) => ({
        //         id: product.id, // Assuming index + 1 as ID
        //         Sl_No: index + 1, // Serial Number
        //         vendor_name: product.procurementInvoice.procurementErpPODetails.VDNAME,
        //         date: dayjs(product.createdAt).format('YYYY-MM-DD'),
        //         insurance_no:product.insurance_no,
        //         item: 'Insurance Charge',
        //         Quantity: product.quantity,
        //         Unit_price: product.unit_price,
        //         total: product.total,
        //         conversion_rate: product.conversion_rate,
        //         amount: product.amount
        //         }));

        //         setApprovalrows(formattedProducts);
        //     }
        // }

    useEffect(() => {
        setOptions({
            insurance_no: '',
            insurance_no_error: '',
            item: 'Insurance Charge',
            item_error: '',
            quantity: '',
            quantity_error: '',
            unit_price: '',
            unit_price_error: '',
            total: '',
            conversion_rate: '',
            conversion_rate_error: '',
            amount: ''
        });
        setSelectedVendorName('');
        setSelectedInvoiceDate('');
        setFile('');
        setApprovalrows([]);
        if(selectedInvoice){
            setOptions(prev => ({...prev, conversion_rate: 1}));
            setSelectedVendorName(selectedInvoice.procurementErpPODetails.VDNAME);
            setSelectedInvoiceDate(selectedInvoice.invoice_date);
            // searchInsuranceChargeFromBackend(selectedInvoice.id);
        }
    }, [selectedInvoice, invoiceList]);

    const handleSweetAlertConfirm = () => {
        setIsOpenSweetAlert(false);
    };

    const submitRequisition = async () => {

        try{
         setIsLoading(true);

         if (file) {
            const response =  await getSASToBlob({uploadType:'INSURANCE'})
 
            const fetchOptions = {
                method: 'PUT',
                body: file,
                headers: {
                    'x-ms-blob-type': 'BlockBlob',
                    'Content-Type': file.type 
                },
            }
             if(response.statusCode===200 && response.data.preSignedUrl){
                
                 try {
                     const res = await fetch(response.data.preSignedUrl, fetchOptions);
         
                     if (res.ok) {
                        payload.blob_name = response.data.blobName
                        payload.file_name = file.name
                     }
                 } catch (error) {
                     console.error('Error uploading file:', error);
                     toast.error('Error uploading file')
                     return
                 }
                 
             }
         }
 
         const response = await addInsuranceCharge(payload);
                
         if(response.statusCode == 200){
             setMessage(`Insurance Charge was created successfully with No: ${response.data.insurance.insurance_no}`);
             setSubmitModalOpen(false);
             setIsOpenSweetAlert(true);
                 setSelectedInvoice(null);
                setPayload(null);

                 getFilteredInvoiceListFromBackend();
                 //searchFreightChargeFromBackend();
         }
 
 
         } catch (error) {
             toast.error("Error in submitting invoice data");
             console.log(error);
         } finally {
             setIsLoading(false);
         }
     };

     const onFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <Card>
                            <CardBody>
                                <div>
                                    <div className='d-flex align-items-center  justify-content-between mb-2 gap-2'>
                                        <div className="d-flex align-items-center gap-2">
                                            <p className='mb-0 me-2 requisition_type_text'>Invoice No </p>
                                            <div>
                                            <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 190 }}
                                                options={invoiceList}
                                                value={selectedInvoice}
                                                onChange={(e, value) => setSelectedInvoice(value)}
                                                // value={productCategoryObj.find(option => option.value === productCategory)}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Select Invoice No"
                                                    />
                                                )}
                                            />
                                        </div>
                                     </div>
                                    </div>
                                    <div className="p-3 mt-3" style={{backgroundColor: '#FAFDFF', border:'1px solid #C3E8FF',borderRadius:'5px'}}>
                                    <div className='d-flex align-items-center mb-2 gap-2 flex-wrap '>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={3}>
                                    {/* <div> */}
                                            {/* <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width: 295 }}
                                                options={productList}
                                                // value={productCategoryObj.find(option => option.value === productCategory)}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Vendor Name"
                                                    />
                                                )}
                                            /> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Vendor Name"
                                                variant="outlined"
                                                value={selectedVendorName}
                                                //onChange={(event) => handleInputChange(event.target.value, 'item')}
                                            
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:295 }}
                                                sx={{ width: '100%'}}
                                            />
                                    {/* </div> */}
                                    </Grid>
                                    <Grid item xs={3}>
                                        <div>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                       className='payment_date date_picker_fullwidth'
                                                    label="Date"
                                                    value={dayjs(selectedInvoiceDate)}
                                                    disabled={true}
                                                //   onChange={handleDateChange}
                                                />
                                            </LocalizationProvider>
                                        </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                        <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Insurance No"
                                                variant="outlined"
                                                value={options.insurance_no}
                                                onChange={(event) => handleInputChange(event.target.value, 'insurance_no')}
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:295 }}
                                                sx={{ width: '100%'}}
                                            />

                                           {options.insurance_no_error && <span className="error-message" style={{ color: 'red' }}>{options.insurance_no_error}</span>}

                                        </div>
                                        </Grid>
                                        <Grid item xs={3}>
                                        <div>
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Item"
                                                variant="outlined"
                                                value={options.item}
                                                //onChange={(event) => handleInputChange(event.target.value, 'item')}
                                                disabled={true}
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:295 }}
                                                sx={{ width: '100%'}}
                                            />

                                        {options.item_error && <span className="error-message" style={{ color: 'red' }}>{options.item_error}</span>}

                                        </div>
                                        </Grid>
                                        </Grid>
                                        {/* <div className="d-flex align-items-center">
                                            <button className="assign_vendor">Submit</button>
                                        </div> */}
                                    </div>
                                    <div className='d-flex align-items-center mb-1 gap-2 flex-wrap mt-3'>
                                    <Grid container item xs={12} sm={12} spacing={1}>
                                    <Grid item xs={3}>
                                    {/* <div> */}
                                            {/* <Autocomplete
                                                className="invoice_autofield"
                                                // id={`product-category`}
                                                sx={{ width:200 }}
                                                options={productList}
                                                // value={productCategoryObj.find(option => option.value === productCategory)}
                                                // onChange={handleProductCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Quantity"
                                                    />
                                                )}
                                            /> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Quantity"
                                                variant="outlined"
                                                value={options.quantity}
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){
                                                    
                                                    handleInputChange(event.target.value, 'quantity')
                                                    }

                                                }}

                                                type='number'
                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:216 }}
                                                sx={{ width: '100%'}}
                                            />
                                         {options.quantity_error && <span className="error-message" style={{ color: 'red' }}>{options.quantity_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={3}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Unit Price"
                                                variant="outlined"
                                                value={options.unit_price}
                                                type='number'
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){

                                                    handleInputChange(event.target.value, 'unit_price')
                                                    }
                                                }}

                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:216 }}
                                                sx={{ width: '100%'}}
                                            />
                                         {options.unit_price_error && <span className="error-message" style={{ color: 'red' }}>{options.unit_price_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Total"
                                                variant="outlined"
                                                value={options.total}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:216 }}
                                                sx={{ width: '100%'}}
                                            />
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Exchange Rate"
                                                variant="outlined"
                                                value={options.conversion_rate}
                                                type='number'
                                                onChange={(event) => {
                                                    if(event.target.value >= 0 && event.target.value < 999999999){
                                                    
                                                    handleInputChange(event.target.value, 'conversion_rate')
                                                    }

                                                }}

                                                // disabled={row.productName == ''}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:216 }}
                                                sx={{ width: '100%'}}
                                            />
                                            {options.conversion_rate_error && <span className="error-message" style={{ color: 'red' }}>{options.conversion_rate_error}</span>}

                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        {/* <div> */}
                                            <TextField
                                                className="invoice_field"
                                                // id={`quantity-${index}`}
                                                label="Amount"
                                                variant="outlined"
                                                value={options.amount}
                                                type='number'
                                                disabled={true}
                                                // onChange={(event) => handleInputChange(index, 'quantity', event.target.value)}
                                                // sx={{ width:216 }}
                                                sx={{ width: '100%'}}
                                            />
                                        {/* </div> */}
                                        </Grid>
                                        <Grid item xs={2}>
                                        <div className='d-flex align-items-center gap-2'>
                                            <p className="mb-0">Insurance Upload</p>
                                            <div className="upload-btn-wrapper ms-2">
                                                <button className="btn">Upload</button>
                                                <input type="file" name="myfile" onChange={(e) => onFileChange(e)} />
                                                {file && <p className="mb-0" style={{ color: "#0060AA" }}>{file.name}</p>}

                                            </div>
                                        </div>
                                        </Grid>
                                        </Grid>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-end mt-2">
                                            <button className="assign_vendor" disabled={!selectedInvoice} onClick={handleSubmit}>Submit</button>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        {/* <div>
                            <Box sx={{ height: 400, width: '100%', marginBottom: '10px', marginTop: '10px' }}>
                            <h4 className="mb-0 requisition_text">Insurance</h4>
                                <DataGrid
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div> */}
                    </div>
                </Container>
            </div>
            <Modal
                isOpen={isSubmitModalOpen}
                onRequestClose={() => setSubmitModalOpen(false)}
                contentLabel="Example Modal"
                className="change_modalbox generatePo_modal"
            >
                <div className='d-flex justify-content-between me-2 mt-3'>
                    <h4 className='ms-3'>Do you want to create this Insurance Charge Invoice?</h4>
                    <div className='d-flex justify-content-end me-3 modal_close'>
                        <i class="ri-close-line" onClick={() => setSubmitModalOpen(false)}></i>
                    </div>
                </div>
                {/* <hr className='mb-2 mt-1 ms-3 me-3'></hr> */}
                <ModalBody className='pt-2'>
                    <div>
                    <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th>Insurance Number</th>
                                            <th>Quantity</th>
                                            <th>Unit Price</th>
                                            <th>Total</th>
                                            <th>Exchange Rate</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td>{options.insurance_no}</td>
                                                <td>{options.quantity}</td>
                                                <td>{options.unit_price}</td>
                                                <td>{options.total}</td>
                                                <td>{options.conversion_rate}</td>
                                                <td>{options.amount}</td>
                                            </tr>
                                        
                                    </tbody>
                                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                                </table>
                    </div>
                    <hr className='mb-2 mt-1 ms-3 me-3'></hr>
                    <div className='d-flex align-items-center mt-4 justify-content-center'>
                        <button className="yes_button d-flex align-items-center" disabled={isLoading} onClick={submitRequisition}>
                            Yes
                        </button>
                        <button className="no_button d-flex align-items-center ms-3" onClick={() => setSubmitModalOpen(false)}>
                            No
                        </button>
                    </div>
                </ModalBody>
            </Modal>
            <SweetAlert
                show={isOpenSweetAlert}
                title={message}
                success
                confirmButtonText="Ok"
                confirmBtnBsStyle="success"
                onConfirm={handleSweetAlertConfirm} // Updated to handleSweetAlertConfirm function

            />
        </React.Fragment>
    );
};

export default Insurance;
